import styled from 'styled-components';

import { Container as ServiceCardContainer } from '../service-card/styles';

export const Container = styled.div`
  position: relative;
  margin-top: 45px;
  box-shadow: 0px 10px 60px 0px rgb(0 0 0 / 10%),
    0px 0px 0px 1px rgb(0 0 0 / 1%);

  @media screen and (min-width: 992px) {
    display: flex;
    align-items: flex-start;
  }

  .divider {
    width: 100%;
    display: flex;
    height: 40px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;

    div {
      flex: 1 1 30%;
      background-color: #185335;
      width: 100%;

      &:first-child {
        flex: 1 1 50%;
        background-color: #000000;
      }

      &:last-child {
        flex: 1 1 20%;
        background-color: #000000;
      }
    }
  }

  .info {
    padding: 64px 16px 16px 16px;

    @media screen and (min-width: 992px) {
      flex: 1 1 40%;
      padding: 130px 16px 0 16px;
    }

    &__title {
      font-weight: bold;
      color: #185335;
      margin: 0;

      &::after {
        display: block;
        content: '';
        height: 1px;
        width: 125px;
        background-color: #185335;
        margin: 15px 0;
      }
    }
  }

  .cards {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 16px;

    ${ServiceCardContainer} {
      width: 100%;

      @media screen and (min-width: 992px) {
        width: ${100 / 3}%;
      }
    }

    @media screen and (min-width: 992px) {
      flex: 1 1 60%;
    }
  }
`;
